import './styles/theme.scss';

import 'uikit';
import mapboxgl from 'mapbox-gl';

document.addEventListener('DOMContentLoaded', () => {
  mapboxgl.accessToken =
    'pk.eyJ1IjoiYmFycXVlIiwiYSI6ImNqbXc4cmM3cjE4OWczcXF5M2FmOXlkOGIifQ.tmKPg77YxcvGXDy-xL2vVQ';

  const geojson = {
    type: 'FeatureCollection',
    features: [
      {
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: [-2.378437, 47.806949],
        },
        properties: {
          'icon-image': 'marker-15',
          title: 'Microbrasserie Barque',
        },
      },
    ],
  };

  const map = new mapboxgl.Map({
    container: 'map-contact',
    style: 'mapbox://styles/barque/cjmw8rpxm0ki12rjmby8zvw0j',
    center: [-2.377605, 47.807326],
    zoom: 14,
  });

  geojson.features.forEach(function(marker) {
    var el = document.createElement('div');
    el.className = 'marker';

    new mapboxgl.Marker(el).setLngLat(marker.geometry.coordinates).addTo(map);
  });
});
